import {
  MDSButton,
  MDSIcon,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIconKind,
  MDSMenuDropdownSlotName,
  MDSMenuDropdownPopover,
  MDSMenuContentList,
  MDSActionMenuWithContent,
  MDSButtonSize,
} from "@/mds";
import { useRef, useState } from "react";

export const HoverActions = ({
  label,
  iconKind,
  contentList,
}: {
  label: string | React.ReactNode;
  iconKind?: MDSIconKind;
  contentList: MDSMenuContentList;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <MDSButton
        ref={triggerRef}
        variant={MDSButtonVariant.Subtle}
        size={MDSButtonSize.Small}
        onPress={() => setIsOpen(prev => !prev)}
      >
        {iconKind && <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={iconKind} />}
        {label}
        <MDSIcon
          slot={MDSButtonSlotName.RightIcon}
          kind={isOpen ? MDSIconKind.AngleUp : MDSIconKind.AngleDown}
        />
      </MDSButton>
      <MDSMenuDropdownPopover triggerRef={triggerRef} isOpen={isOpen} onOpenChange={setIsOpen}>
        <MDSActionMenuWithContent contentList={contentList} slot={MDSMenuDropdownSlotName.Menu} />
      </MDSMenuDropdownPopover>
    </>
  );
};
